import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-navigation-angle-double-down-icon',
  templateUrl: './navigation-angle-double-down.component.html'
})
export class NavigationAngleDoubleDownComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
